<script setup lang="ts">
import AdvantageItem from './AdvantageItem.vue';
import Inventory from '@files/advantages/inventory.svg?component';
import Experience from '@files/advantages/experience.svg?component';
import Money from '@files/advantages/money.svg?component';
import Support from '@files/advantages/support.svg?component';
</script>

<template>
    <div class="advantages-container">
        <AdvantageItem
            :image-component="Inventory"
            title="موجودی کامل"
            description="با ارائه حداکثری موجودی، برنامه‌ریزی سفر را برای هر زمان و مقصدی ممکن کرده‌ایم!"
        />
        <AdvantageItem
            :image-component="Experience"
            title="تجربه دلچسب خرید"
            description="دغدغه ما در طراحی، سادگی و خرید آسان است!"
        />
        <AdvantageItem
            :image-component="Money"
            title="مشاور در مدیریت هزینه"
            description="با ارائه قابلیت‌های هوشمند کمک می‌کنیم تا سفری به‌صرفه داشته باشید!"
        />
        <AdvantageItem
            :image-component="Support"
            title="پشتیبان سفر"
            description="از لحظه تصمیم تا پایان سفر کنار شما هستیم!"
        />
    </div>
</template>

<style lang="scss" scoped>
.advantages-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    max-width: $app-container-max-width;
    margin: auto;
    padding-block: 20px;
    overflow-x: auto;
    @include no-scrollbar;
    @include f-gap(32px);
    @include mobile-only {
        @include f-gap(8px);
    }
}
</style>
